
const PearDiamond = ({...props}) => {
  return (
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 100 100" xmlSpace="preserve" fill="currentColor" {...props}>

<path d="M83.54,38.66c0-0.01,0-0.02,0-0.03c-0.14-9.27-2.68-17.46-7.36-23.7C70.1,6.85,60.81,2.4,50,2.4
	S29.9,6.85,23.83,14.94c-4.68,6.23-7.23,14.43-7.36,23.7c-0.05,3.66,0.26,7.52,0.95,11.47c1.08,6.25,3.48,12.67,7.15,19.07
	c9.61,16.78,24.94,28.2,25.09,28.31c0.04,0.03,0.08,0.04,0.12,0.06c0.02,0.01,0.03,0.02,0.05,0.03c0.06,0.02,0.12,0.03,0.19,0.03
	s0.13-0.01,0.19-0.03c0.02-0.01,0.03-0.02,0.05-0.03c0.04-0.02,0.08-0.03,0.12-0.06c0.15-0.11,15.48-11.53,25.09-28.31
	c3.66-6.4,6.07-12.81,7.14-19.07C83.27,46.16,83.59,42.32,83.54,38.66C83.54,38.66,83.54,38.66,83.54,38.66z M57.62,75.05
	l-6.63-4.14l9.95-9.12L57.62,75.05z M50,95.32l-7.26-19.07L50,71.71l7.26,4.54L50,95.32z M42.38,75.05l-3.32-13.26l9.95,9.12
	L42.38,75.05z M38.31,16.78l9.79,4.08l-13.05,3.26L38.31,16.78z M50,3.88l10.98,11.89L50,20.35l-10.98-4.57L50,3.88z M61.69,16.78
	l3.26,7.34L51.9,20.86L61.69,16.78z M50,70.19L38.52,59.66l-6.9-20.7l2.89-13.47L50,21.62l15.49,3.87l2.89,13.47l-6.9,20.7L50,70.19
	z M30.73,37.42l-5.33-8.61l7.79-2.87L30.73,37.42z M30.85,40.45l5.84,17.53l-10.44-9.6L30.85,40.45z M69.15,40.45l4.59,7.93
	l-10.43,9.6L69.15,40.45z M69.28,37.42l-2.46-11.48l7.79,2.87L69.28,37.42z M66.45,24.52l-3.54-7.97l12.18-0.63l-0.17,11.72
	L66.45,24.52z M33.56,24.52l-8.47,3.12l-0.17-11.72l12.18,0.63L33.56,24.52z M23.9,28.31l-6.14,8.37c0.4-7.47,2.44-14.13,5.98-19.48
	L23.9,28.31z M24.46,29.57l5.84,9.44l-4.9,8.46l-7.58-8.85L24.46,29.57z M26.07,49.84l11.39,10.48l3.67,14.66l-15.44-6.51
	L26.07,49.84z M62.54,60.32l11.39-10.48l0.39,18.63l-15.44,6.51L62.54,60.32z M69.7,39.01l5.84-9.44l6.63,9.04l-7.58,8.85
	L69.7,39.01z M76.1,28.31l0.16-11.11c3.53,5.35,5.58,12.01,5.98,19.48L76.1,28.31z M74.5,14.76l-12.25,0.63L51.4,3.63
	C60.81,3.98,68.93,7.89,74.5,14.76z M48.61,3.63L37.75,15.39L25.5,14.76C31.07,7.89,39.19,3.98,48.61,3.63z M17.68,40.29l7.22,8.43
	l-0.37,17.9c-2.99-5.62-4.98-11.23-5.93-16.71C18.02,46.6,17.73,43.38,17.68,40.29z M26.53,70.13l15,6.32l7.14,18.73
	C44.61,91.87,34.09,82.62,26.53,70.13z M51.33,95.19l7.14-18.73l15-6.32C65.91,82.62,55.39,91.87,51.33,95.19z M75.48,66.61
	l-0.37-17.9l7.22-8.43c-0.05,3.1-0.34,6.32-0.91,9.61C80.47,55.38,78.47,60.99,75.48,66.61z"/>
</svg>

  )
}

export default PearDiamond